var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.getShowValue(_vm.item)
    ? _c(
        "el-form-item",
        {
          key: _vm.index,
          staticClass: "wk-form-item",
          class: [_vm.item.className || "", `is-${_vm.item.form_type}`],
          style: {
            width: _vm.item.style_percent
              ? `${_vm.item.style_percent}%`
              : "auto",
          },
          attrs: {
            prop: `${_vm.propPrefix || ""}${_vm.item.field}`,
            rules: _vm.item.rules,
          },
        },
        [
          _c(
            "template",
            { slot: "label" },
            [
              _vm._v("\n    " + _vm._s(_vm.item.name) + "\n    "),
              _vm.item.tipType == "tooltip"
                ? _c(
                    "el-tooltip",
                    { attrs: { effect: "dark", placement: "top" } },
                    [
                      _c("div", {
                        attrs: { slot: "content" },
                        domProps: { innerHTML: _vm._s(_vm.getTips(_vm.item)) },
                        slot: "content",
                      }),
                      _vm._v(" "),
                      _c("i", { staticClass: "wk wk-help wk-help-tips" }),
                    ]
                  )
                : _c("span", { staticStyle: { color: "#999" } }, [
                    _vm._v(
                      "\n      " + _vm._s(_vm.getTips(_vm.item)) + "\n    "
                    ),
                  ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("wk-field", {
            attrs: {
              item: _vm.item,
              index: _vm.index,
              "field-from": _vm.fieldFrom,
              "ignore-fields": _vm.ignoreFields,
              disabled: _vm.disabled,
            },
            on: { change: _vm.fieldChange },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({ data, index }) {
                    return [
                      _vm._t("default", null, { data: data, index: index }),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }